/**
 * Converts a standard Vimeo video URL to its embed URL format
 */
export default function convertVimeoToEmbed(vimeoUrl: string): string | null {
  // Regular expression to extract the video ID from various Vimeo URL formats
  const regexPatterns = [
    /vimeo\.com\/([0-9]+)/, // Standard URL: https://vimeo.com/12345678
    /vimeo\.com\/channels\/[^/]+\/([0-9]+)/, // Channel URL: https://vimeo.com/channels/channelname/12345678
    /vimeo\.com\/groups\/[^/]+\/videos\/([0-9]+)/, // Group URL: https://vimeo.com/groups/groupname/videos/12345678
    /vimeo\.com\/album\/[^/]+\/video\/([0-9]+)/, // Album URL: https://vimeo.com/album/albumname/video/12345678
    /vimeo\.com\/showcase\/[^/]+\/video\/([0-9]+)/, // Showcase URL: https://vimeo.com/showcase/showcasename/video/12345678
    /player\.vimeo\.com\/video\/([0-9]+)/ // Player URL: https://player.vimeo.com/video/12345678
  ];

  // Try each pattern until we find a match
  for (const pattern of regexPatterns) {
    const match = vimeoUrl.match(pattern);
    if (match && match[1]) {
      // Return the standard embed URL format
      return `https://player.vimeo.com/video/${match[1]}`;
    }
  }

  // If no match was found, return null
  return null;
}
